import script from "./FormTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTextArea.vue?vue&type=script&setup=true&lang=js"

import "./FormTextArea.vue?vue&type=style&index=0&id=27ba70b8&lang=scss"

const __exports__ = script;

export default __exports__